import React from 'react';
import { ArrowClockwiseIcon, ShieldCheckIcon, TruckIcon } from '@fronton/icons-react';
import { Typography } from 'common/components';
import { additionalInfo, additionalInfoRow } from './additional-info-styles';

export const AdditionalInfo = () => (
  <ul className={additionalInfo}>
    <li className={additionalInfoRow}>
      <TruckIcon type='outline' size='l' color='text-primary'/>
      <Typography size="body_long" variant="s">Привезем через 21 день</Typography>
    </li>
    <li className={additionalInfoRow}>
      <ShieldCheckIcon type='outline' size='l' color='text-primary'/>
      <Typography size="body_long" variant="s">Гарантия 2 года</Typography>
    </li>
    <li className={additionalInfoRow}>
      <ArrowClockwiseIcon type='outline' size='l' color='text-primary'/>
      <Typography size="body_long" variant="s">Возврат до года</Typography>
    </li>
  </ul>
);
